import { cn } from "../lib/utils";
import { Button } from "./ui/button";

export default function MainButton({
  Icon,
  title,
  onClick,
  disabled,
  className,
  ...props
}) {
  return (
    <Button
      {...props}
      className={cn(
        "w-fit h-11 bg-gradient-to-tr from-blue-700 to-blue-400 text-white hover:from-blue-400 hover:to-blue-700 rounded-xl shadow-md hover:shadow-lg transition-all duration-300",
        className
      )}
      variant="primary"
      onClick={onClick}
      disabled={disabled}
    >
      {Icon && <Icon className="h-4 w-4" />}
      {title}
    </Button>
  );
}
